function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.005 0C10.2151 0 12.2128 0.893969 13.6585 2.34L16 0V7H8.99562L12.2176 3.78C11.1379 2.6909 9.65848 2.00114 7.99911 2C5.39003 2.00251 3.17137 3.67175 2.35147 6H2.33378C2.21976 6.32168 2.13245 6.6559 2.07452 7H0.0616952C0.552428 3.05239 3.91112 0 7.995 0H8.005Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 9V16L2.34146 13.66C3.78717 15.106 5.78489 16 7.995 16L8.005 16C12.0889 16 15.4476 12.9476 15.9383 9H13.9255C13.8676 9.3441 13.7802 9.67832 13.6662 10H13.6485C12.8287 12.3282 10.6101 13.9974 8.00118 14C6.34169 13.9989 4.86221 13.3092 3.78236 12.22L7.00438 9H0Z",
  fill: "white"
}));

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e608ae79.svg";
export { ForwardRef as ReactComponent };